import { render, staticRenderFns } from "./TutorSetType.vue?vue&type=template&id=7f788c00&scoped=true&"
import script from "./TutorSetType.vue?vue&type=script&lang=js&"
export * from "./TutorSetType.vue?vue&type=script&lang=js&"
import style0 from "./TutorSetType.vue?vue&type=style&index=0&id=7f788c00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f788c00",
  null
  
)

export default component.exports